import {
  ActivityChangeExtensionOptions,
  createActivityChangeExtension,
  createActivityChangeExtensions,
  useActivityChangeExtensions,
} from '@spotify/plugin-confidence-activity-react';

export const WorkflowUpdatesChangeExtensions = createActivityChangeExtensions(
  'workflow-updates-change',
);

export const useWorkflowUpdatesChangeExtensions = () => {
  return useActivityChangeExtensions(WorkflowUpdatesChangeExtensions);
};

export const createWorkflowUpdatesChangeExtension = (
  options: ActivityChangeExtensionOptions,
) => {
  return createActivityChangeExtension(options);
};
